import React from "react";
import "./Paywall.css"; // Assuming your CSS is saved in this file
import PayNowButton from "./PayNow";

const Paywall = ({ imageUrl, videoUrl, buttonText, onButtonClick }) => {
  return (
    <div className="media-stack">
      <img
        src={imageUrl}
        alt="Descriptive Alt Text"
        className="media-stack-image"
      />
      <video controls className="media-stack-video" autoPlay loop muted>
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {/* <button onClick={onButtonClick} className="media-stack-button">
        {buttonText}
      </button> */}
      <PayNowButton></PayNowButton>
    </div>
  );
};

export default Paywall;
